import { render, staticRenderFns } from "./BucketShareDialog.vue?vue&type=template&id=08f7d3a6"
import script from "./BucketShareDialog.vue?vue&type=script&lang=js"
export * from "./BucketShareDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports